import { ReactNode, createContext, useState } from "react";
import { Item } from "@models/item";

interface ItemContextType {
  item: Item | null;
  setItem: (item: Item) => void;
}

export const ItemContext = createContext<ItemContextType>({
  item: null,
  setItem: () => {},
});

export const ItemProvider: React.FC<{ children: ReactNode; item: Item }> = ({ children, item }) => {
  const [currentItem, setCurrentItem] = useState<Item>(item);

  return (
    <ItemContext.Provider value={{ item: currentItem, setItem: setCurrentItem }}>
      {children}
    </ItemContext.Provider>
  );
};
